module.exports = __webpack_public_path__ + "static/media/box.2c90e58b.svg";